import { createStyles, makeStyles, Theme } from '@material-ui/core';

export interface VerifiedItemsStylesProps {
    
}
export const useStyles = makeStyles<Theme, VerifiedItemsStylesProps>((theme: Theme) =>
  createStyles({
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
    },
    breadcrumbsContainer: {
      marginBottom: "40px",
      width: "95%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  }),
);